import React from "react";

import { Stepper as MuiStepper, Step, StepContent, StepLabel, Typography, withStyles } from "@material-ui/core";

import useColourPalette from "components/visuals/useColourPalette";

import StepIcon from "./StepIcon";

import { useAppSelector } from "store";
import { selectActiveStep, selectCandidateRange, selectCandidateStore } from "modules/customer/tools/product/storeRangeFilters/storeRangeFiltersSlice";

const StyledStepper = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.dark,
        paddingLeft: theme.spacing(0)
    }
}))(MuiStepper);

const Stepper: React.FC = () => {
    const colourPalette = useColourPalette();
    const activeStep = useAppSelector(selectActiveStep);
    const candidateStore = useAppSelector(selectCandidateStore);
    const candidateRange = useAppSelector(selectCandidateRange);

    return (
        <StyledStepper activeStep={activeStep} orientation="vertical">
            <Step expanded>
                <StepLabel StepIconComponent={StepIcon}>
                    <Typography variant="subtitle1" component="div">
                        Select a store
                    </Typography>
                </StepLabel>
                <StepContent style={{ color: colourPalette.comparators[0] }}>
                    <Typography variant="h6" component="div" noWrap>
                        {candidateStore?.name}
                    </Typography>
                </StepContent>
            </Step>
            <Step expanded>
                <StepLabel StepIconComponent={StepIcon}>
                    <Typography variant="subtitle1" component="div">
                        Select a product range
                    </Typography>
                </StepLabel>
                <StepContent style={{ color: colourPalette.comparators[0] }}>
                    <Typography variant="h6" component="div" noWrap>
                        {candidateRange?.name}
                    </Typography>
                </StepContent>
            </Step>
        </StyledStepper>
    );
};

export default Stepper;
